var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3078 4.49098C33.5644 3.87621 34.4354 3.87621 34.692 4.49098L42.5023 23.2005C42.6048 23.4462 42.83 23.6191 43.0938 23.6548L63.4542 26.4105C64.1043 26.4985 64.3361 27.3199 63.8278 27.7348L48.0159 40.6377C47.7944 40.8185 47.6949 41.1094 47.7594 41.3879L52.8204 63.2582C52.9755 63.9284 52.2219 64.4364 51.6589 64.0412L34.4308 51.9495C34.1722 51.768 33.8276 51.768 33.5691 51.9495L16.3409 64.0412C15.7779 64.4364 15.0243 63.9284 15.1794 63.2582L20.24 41.3879C20.3045 41.1094 20.205 40.8185 19.9835 40.6377L4.17205 27.7348C3.66373 27.3199 3.89547 26.4985 4.54565 26.4105L24.906 23.6548C25.1699 23.6191 25.395 23.4462 25.4976 23.2005L33.3078 4.49098Z",
    fill: "#4E4B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStar);
export default __webpack_public_path__ + "static/media/filled_star.606bfbf82bc7230e07eeead183bb0927.svg";
export { ForwardRef as ReactComponent };